import Landing from "../../components/landing/Landing";
import BlogScreen from "./blogScreen/BlogScreen";
import WebLayout from "../../components/WebLayout";
import axios from "axios";
import { baseUrl, getBlog } from "../../utils/apiData";
import Loader from "../../components/loader/Loader.jsx";
import { Fragment, useEffect, useState } from "react";

const Blogs = () => {
  const [loader, setLoader] = useState(false);
  const [blogList, setBlogList] = useState([]);
  const [category, setCategory] = useState([]);
  const [categoryId, setCategoryId] = useState("");

  const [search, setSearch] = useState("");

  const getBlogsApi = async () => {
    setLoader(true);
    try {
      const res = await axios.post(`${baseUrl}/${getBlog}`, {
        category_id: `${categoryId}`,
        search: `${search}`,
      });

      if (res?.data?.success) {
        setBlogList(res?.data?.data?.blogs);
        setCategory(res?.data?.data?.categories);
      }
    } catch (error) {
      console.log(error);
    }
    setLoader(false);
  };

  useEffect(() => {
    getBlogsApi();
  }, [categoryId]);

  useEffect(() => {
    const timoutId = setTimeout(() => {
      getBlogsApi();
    }, 1000);

    return () => clearTimeout(timoutId);
  }, [search]);

  return (
    <WebLayout>
      {loader ? (
        <Loader />
      ) : (
        <Fragment>
          <Landing title="News, Blogs" from="Home" page="Our News and events" />
          <BlogScreen
            dataList={blogList}
            categoryList={category}
            search={search}
            setSearch={setSearch}
            categoryId={categoryId}
            setCategoryId={setCategoryId}
          />
        </Fragment>
      )}
    </WebLayout>
  );
};

export default Blogs;
